<template>
    <div class="container">
        <menu-option v-bind:is-white="true" v-bind:back="false" v-on:help="help()"  v-if="!helpClick" v-bind:is-help="true"></menu-option>
        <div class=" container container-black-bg" v-if="helpClick">
            <img src="assets/img/Close.png" alt="" class="margin" @click="help" v-if="helpClick">
            <div class="center-text-container"><p>このゲームは<ruby>日本語<rt>にほんご</rt></ruby>で
                キャラクターに<ruby>話<rt>はな</rt></ruby>しかける
                ゲームです。
                <ruby>練習<rt>れんしゅう</rt></ruby>はテキストの<ruby>音読<rt>おんどく</rt></ruby>、
                <ruby>実践<rt>じっせん</rt></ruby>はフリートークです。</p></div>


        </div>
        <transition :css="false" @enter="enterText" @leave="leaveAnimation" appear>
            <div v-for="character in characters" class="img-container" v-if="!goNext" @click="leaveAnimation">
                <img :src="character.normalImage" class="img-container_img" v-if="!helpClick">
                <img :src="character.badAnswerImg" class="img-container_img" v-if="helpClick">

                <div class="dialog" v-if="!helpClick">
                    <p class="dialog_name" v-html="getCharacter.name"></p>
                    <p class="dialog_text" v-html="character.characterDescription"><span v-if="allTextAppear"
                                                                                         class="anim">|</span></p>
                    <span class="dialog_next" 　><ruby>次<rt>つぎ</rt>へ</ruby><img
                            src="assets/img/next.png" class="blink-1"></span>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import {character} from "../data/Character";
    import {mapActions} from 'vuex';
    import CharacterTalk from "./CharacterTalk";
    import {mapGetters} from 'vuex'
    import anime from 'animejs'
    import MenuOption from "./MenuOption";

    export default {
        name: "CharactersSelection",
        data() {
            return {
                characters: character,
                allTextAppear: true,
                goNext: false,
                helpClick: false

            }
        },
        computed: {
            ...mapGetters(['getCharacter'])
        },
        components: {MenuOption, CharacterTalk},
        methods: {
            ...mapActions({
                chooseCharacter: 'chooseCharacter'
            }),
            moveToModeInstruction() {
                this.goNext = true;
            },
            enterText(el, done) {
                const ani = anime({
                    targets: el,
                    opacity: [0, 1],
                    easing: 'easeInQuad'
                })
            },
            leaveAnimation(el, done) {
                const ani = anime({
                    targets: el,
                    opacity: [1, 0],
                    easing: 'easeInQuad'
                })
                ani.finished.then(() => {
                    done;
                    this.$router.push('/instruction')
                })
            },
            help() {
                this.helpClick = !this.helpClick;
                console.log('HELP');
            }

        },
        mounted() {
            this.chooseCharacter(this.characters[0])
        }
    }
</script>

<style scoped>

</style>
